import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw1707Handlers = [

  // 催促メール定型文取得処理
  http.post(PlessService.SERVICE.getRemindMailTemp.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(getRemindMailTempResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 催促メール情報送信
  http.post(PlessService.SERVICE.sendRemindMailInfo.url, async ({ request }) => {
    const req = await request.json();
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
];

const getRemindMailTempResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      RemindMailTempList: [
        {
          'RemindMailTempId': '0',
          'Title': '催促メール１',
          'MainText': 'お世話になっております。'
        },
        {
          'RemindMailTempId': '1',
          'Title': '催促メール２',
          'MainText': 'お世話になっております。'
        },
        {
          'RemindMailTempId': '2',
          'Title': '催促メール３',
          'MainText': 'お世話になっております。'
        },
      ]
    }
  }
};